import { useLanguage } from '../../../../context/LanguageContext';
import profilePic from '../../../../assets/images/main_profile_picture.jpeg';

export function HeroSection() {
    const { t } = useLanguage();
    const cvUrl = process.env.REACT_APP_CV_URL || '#';

    return (
        <section id="hero" className="min-h-screen flex flex-col items-center justify-center bg-white dark:bg-slate-900 pt-16 px-4">
            <img
                src={profilePic}
                alt="Pablo Sandoval"
                className="profile_pic floating ring-4 ring-blue-600/20 dark:ring-blue-400/20 mb-8"
            />

            <h1 className="text-4xl md:text-6xl font-bold tracking-tight text-slate-900 dark:text-white text-center">
                {t('hero.greeting')}{' '}
                <span className="text-blue-600 dark:text-blue-400">{t('hero.name')}</span>
            </h1>

            <div className="typewriter mt-4">
                <p className="text-xl md:text-2xl text-slate-600 dark:text-slate-400">
                    {t('hero.tagline')}
                </p>
            </div>

            <p className="max-w-2xl text-center text-lg text-slate-500 dark:text-slate-400 mt-6 leading-relaxed">
                {t('hero.intro')}
            </p>

            <div className="flex items-center gap-6 mt-8">
                <a href="https://github.com/SPablo2191" target="_blank" rel="noreferrer noopener" className="text-slate-500 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                    <i className="bi bi-github text-2xl" />
                </a>
                <a href="https://www.linkedin.com/in/pablo-sandoval-191/" target="_blank" rel="noreferrer noopener" className="text-slate-500 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                    <i className="bi bi-linkedin text-2xl" />
                </a>
                <a href="https://www.instagram.com/alt_pab/" target="_blank" rel="noreferrer noopener" className="text-slate-500 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                    <i className="bi bi-instagram text-2xl" />
                </a>
                <a href="https://www.youtube.com/@alt_pab" target="_blank" rel="noreferrer noopener" className="text-slate-500 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                    <i className="bi bi-youtube text-2xl" />
                </a>
                <a href="https://www.tiktok.com/@alt_pab" target="_blank" rel="noreferrer noopener" className="text-slate-500 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                    <i className="bi bi-tiktok text-2xl" />
                </a>
            </div>

            <div className="flex gap-4 mt-8">
                <a
                    href={cvUrl}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"
                >
                    <i className="bi bi-download mr-2" />
                    {t('hero.cta.cv')}
                </a>
                <button
                    onClick={() => document.getElementById('experience')?.scrollIntoView({ behavior: 'smooth' })}
                    className="px-6 py-3 border border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-300 hover:border-blue-600 dark:hover:border-blue-400 hover:text-blue-600 dark:hover:text-blue-400 font-medium rounded-lg transition-colors"
                >
                    {t('hero.cta.work')}
                </button>
            </div>

            <div className="mt-16 animate-bounce text-slate-400">
                <i className="bi bi-chevron-down text-2xl" />
            </div>
        </section>
    );
}
